import MerchantAppData from '../Model/MerchantAppData'
import TableCanvasView from '../components/merchant/components/table/TableCanvasView';
import Util from '../util/UtilClass';

class TemporaryTableQr {
    color = "transparent"
    constructor(){

    }
    getColorSetting = (description) => {
        return MerchantAppData.data.getMerchantSettingValue(description)
    }
    getDangerColor = () => {
        return this.getColorSetting('table_canvas_view_danger_threshold_color') || TableCanvasView.DEFAULT_DANGER_COLOR
    }
    getWarningColor = () => {
        return this.getColorSetting('table_canvas_view_warning_threshold_color') || TableCanvasView.DEFAULT_WARNING_COLOR
    }
    setColor = (elapsedMinute) => {
        const duration = this.duration
        let warningThreshold = duration * 0.5
        let dangerThreshold = duration * 0.75
        if (elapsedMinute > dangerThreshold) {
            this.color = this.getDangerColor()
        }
        else if (elapsedMinute > warningThreshold) {
            this.color = this.getWarningColor()
        }
        else {
            this.color = "transparent"
        }
    }

    calculateElapsedTime = () => {
        const { hms, elapsedMinute, } = Util.calculateElapsedTime(moment(this.created_at), moment())
        this.elapsed = hms
        this.setColor(elapsedMinute)
    }
}

export default TemporaryTableQr;